import { Menu } from 'antd'
import { Typography } from 'components/Typography'
import { itemsActions } from './constants'
import { TMenuItems } from './types'
import { routes } from '../../../../router'
import useRouter from '../../../../hooks/useRouter'

export const MenuItems = ({ uuid, setVisible }: TMenuItems) => {
  const { navigate } = useRouter()

  const handleClick = (key: string) => {
    setVisible(false)
    switch (key) {
      case 'edit':
        return navigate(`${routes.gpo}/${uuid}`)
      default:
        return
    }
  }

  return (
    <Menu className="menu-items-wrapper">
      {itemsActions.map((i) => (
        <Menu.Item key={i.key} onClick={() => handleClick(i.key)}>
          <Typography.Body1>{i.label}</Typography.Body1>
        </Menu.Item>
      ))}
    </Menu>
  )
}
